import { render } from "./common.vue?vue&type=template&id=0ece0b59"
import script from "./common.vue?vue&type=script&lang=js"
export * from "./common.vue?vue&type=script&lang=js"

import "./common.vue?vue&type=style&index=0&id=0ece0b59&lang=less"
script.render = render

export default script